module.exports = __webpack_public_path__ + "static/media/attributes-icon.d2c7a460.svg";